<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img
                src="@/assets/images/pages/register.png"
                alt="sign-up"
                class="mx-auto"
                style="width: 100%; height: 100%; object-fit: contain;"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
              <div class="px-8 pt-8 register-tabs-container">
                <div class="vx-card__title mb-4">
                  <h2 class="mb-4">Registration Closed</h2>
                  <div class="mb-6 p-4 bg-warning text-white rounded">
                    <div class="flex items-start">
                      <feather-icon icon="AlertTriangleIcon" svgClasses="w-6 h-6 mr-3 flex-shrink-0 mt-1" />
                      <div>
                        <p class="font-semibold mb-2">Service Deprecation Notice</p>
                        <p class="mb-2">Hoverlay Studio will be retired on September 30th, 2026.</p>
                        <p>New account registration has been disabled.</p>
                      </div>
                    </div>
                  </div>
                  <p>If you have an existing account, you can still <router-link to="/pages/login" class="text-primary font-semibold">login here</router-link>.</p>
                </div>

                <!-- Registration form disabled -->
                <!-- <register-jwt></register-jwt> -->

                <!-- <vs-tabs>
                                  <vs-tab label="JWT">
                                    <register-jwt></register-jwt>
                                  </vs-tab>

                                  <vs-tab label="Firebase">
                                    <register-firebase></register-firebase>
                                  </vs-tab>

                                  <vs-tab label="Auth0">
                                    <register-auth0></register-auth0>
                                  </vs-tab>
                                </vs-tabs> -->
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import RegisterJwt from './RegisterJWT.vue'
import RegisterFirebase from './RegisterFirebase.vue'
import RegisterAuth0 from './RegisterAuth0.vue'

export default {
  components: {
    RegisterJwt,
    RegisterFirebase,
    RegisterAuth0,
  },
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
